module.exports = __webpack_public_path__ + "static/logo_history-1e78c16457f831a4daade5e74e02bd53.svg";